import User from "./User" ;
import Lead from "./Lead" ;
import D3EDate from "../classes/D3EDate" ;
import LeadRemainderStatus from "../classes/LeadRemainderStatus" ;
import DateTime from "../core/DateTime" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  LeadRemainder extends  DBObject {  private static readonly _CREATEDBY: number = 0 ;
  private static readonly _CREATEDDATE: number = 1 ;
  private static readonly _DESCRIPTION: number = 2 ;
  private static readonly _LEAD: number = 3 ;
  private static readonly _REMAINDERDATE: number = 4 ;
  private static readonly _STATUS: number = 5 ;
  private static readonly _TITLE: number = 6 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _title: string = '' ;
  private _lead: Lead = null ;
  private _remainderDate: D3EDate = null ;
  private _description: string = '' ;
  private _status: LeadRemainderStatus = LeadRemainderStatus.Pending ;
  private _createdBy: User = null ;
  private _createdDate: DateTime = null ;
 public constructor ( d3eParams ? : Partial<{createdBy: User, createdDate: DateTime, description: string, lead: Lead, remainderDate: D3EDate, status: LeadRemainderStatus, title: string}> ) {
 super();

this.setCreatedBy(d3eParams?.createdBy ?? null);

this.setCreatedDate(d3eParams?.createdDate ?? null);

this.setDescription(d3eParams?.description ?? '');

this.setLead(d3eParams?.lead ?? null);

this.setRemainderDate(d3eParams?.remainderDate ?? null);

this.setStatus(d3eParams?.status ?? LeadRemainderStatus.Pending);

this.setTitle(d3eParams?.title ?? '');
 }
  public get d3eType (  ) : string {
 return 'LeadRemainder' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get title (  ) : string {
 return this._title ; 
 }
  public setTitle ( val : string ) : void {
 let isValChanged :boolean=this._title !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadRemainder._TITLE,this._title);

this._title=val;

this.fire('title',this);
 }
  public get lead (  ) : Lead {
 return this._lead ; 
 }
  public setLead ( val : Lead ) : void {
 let isValChanged :boolean=this._lead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadRemainder._LEAD,this._lead);

this.updateObservable('lead',this._lead,val);

this._lead=val;

this.fire('lead',this);
 }
  public get remainderDate (  ) : D3EDate {
 return this._remainderDate ; 
 }
  public setRemainderDate ( val : D3EDate ) : void {
 let isValChanged :boolean=this._remainderDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadRemainder._REMAINDERDATE,this._remainderDate);

this._remainderDate=val;

this.fire('remainderDate',this);
 }
  public get description (  ) : string {
 return this._description ; 
 }
  public setDescription ( val : string ) : void {
 let isValChanged :boolean=this._description !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadRemainder._DESCRIPTION,this._description);

this._description=val;

this.fire('description',this);
 }
  public get status (  ) : LeadRemainderStatus {
 return this._status ; 
 }
  public setStatus ( val : LeadRemainderStatus ) : void {
 let isValChanged :boolean=this._status !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadRemainder._STATUS,this._status.index);

this._status=val;

this.fire('status',this);
 }
  public get createdBy (  ) : User {
 return this._createdBy ; 
 }
  public setCreatedBy ( val : User ) : void {
 let isValChanged :boolean=this._createdBy !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadRemainder._CREATEDBY,this._createdBy);

this.updateObservable('createdBy',this._createdBy,val);

this._createdBy=val;

this.fire('createdBy',this);
 }
  public get createdDate (  ) : DateTime {
 return this._createdDate ; 
 }
  public setCreatedDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._createdDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(LeadRemainder._CREATEDDATE,this._createdDate);

this._createdDate=val;

this.fire('createdDate',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case LeadRemainder._TITLE : {
 return this._title ; 
 }

case LeadRemainder._LEAD : {
 return this._lead ; 
 }

case LeadRemainder._REMAINDERDATE : {
 return this._remainderDate ; 
 }

case LeadRemainder._DESCRIPTION : {
 return this._description ; 
 }

case LeadRemainder._STATUS : {
 return this._status.index ; 
 }

case LeadRemainder._CREATEDBY : {
 return this._createdBy ; 
 }

case LeadRemainder._CREATEDDATE : {
 return this._createdDate ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : LeadRemainder {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :LeadRemainder=( dbObj as LeadRemainder );

obj.id=this.id;

obj.setTitle(this._title);

obj.setLead(this._lead);

obj.setRemainderDate(this._remainderDate);

obj.setDescription(this._description);

obj.setStatus(this._status);

obj.setCreatedBy(this._createdBy);

obj.setCreatedDate(this._createdDate);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case LeadRemainder._TITLE : {
 this.setTitle(( value as string ));
 break; }

case LeadRemainder._LEAD : {
 this.setLead(( value as Lead ));
 break; }

case LeadRemainder._REMAINDERDATE : {
 this.setRemainderDate(( value as D3EDate ));
 break; }

case LeadRemainder._DESCRIPTION : {
 this.setDescription(( value as string ));
 break; }

case LeadRemainder._STATUS : {
 this.setStatus(LeadRemainderStatus.values [ ( value as number ) ]);
 break; }

case LeadRemainder._CREATEDBY : {
 this.setCreatedBy(( value as User ));
 break; }

case LeadRemainder._CREATEDDATE : {
 this.setCreatedDate(( value as DateTime ));
 break; }
 }
 }
 }